import { Component, HostListener } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ContactUsCmsResource } from '@cardihab/content-cache';
import { map, Observable } from 'rxjs';
import CONTACT_US from 'src/app/apollo/queries/singletypes/contactUs';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ContentService } from 'src/app/services/content.service';
import { BUILD_NUMBER, PACKAGE_VERSION, SEQUENTIAL_BUILD_NUMBER } from 'src/version';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.page.html',
  styleUrls: ['./contact-us.page.scss'],
})
export class ContactUsPage {

  title = 'Contact Us';
  versionIdentifier = '';
  contactUsHtml$: Observable<string | undefined>;

  constructor(
    private contentService: ContentService,
    private analyticsService: AnalyticsService,
  ) {
    this.analyticsService.tagRoute('unauthenticated/contactus');
    this.versionIdentifier = `Version ${PACKAGE_VERSION} ${BUILD_NUMBER}-${SEQUENTIAL_BUILD_NUMBER}`;
    this.contactUsHtml$ = this.contentService.watchContent(
      ContactUsCmsResource,
      {
        product: 'smarthf',
      },
    ).pipe(map(res => {
      if (res.length) {
        const result = res[0] as ContactUsCmsResource
        return result.content ?? '';
      }
      return '';
    }));
  }

  @HostListener('document:click', ['$event'])
  clickout(_event: Event): boolean {
    const event = _event || window.event;
    const element = event.target as Element;
    if (element) {
      if ('A' === element.tagName) {
        const url = element.getAttribute('href');
        if (url) {
          Browser.open({ url });
        }
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
    }
    return true;
  }

}
